import { connect } from 'react-redux'
import { AppleButton } from '../../../Components/AppleButton'

const mapStateToProps = (state, params) => {
  return {
    children: state.localization.dictionary.login.contApple
  }
}

const AppleButtonConnected = connect(
  mapStateToProps
)(AppleButton)

export {
  AppleButtonConnected as AppleButton
}
